export const isDiscountMessageActive = (discountMessage) => {
  if (!discountMessage) {
    return false;
  }

  const dateNow = new Date().getTime();

  if (discountMessage.startDate) {
    const startDate = new Date(discountMessage.startDate);
    const startDateTimestamp = startDate.getTime();

    if (startDateTimestamp > dateNow) {
      return false;
    }
  }

  if (discountMessage.endDate) {
    const endDate = new Date(discountMessage.endDate);
    const endDateTimestamp = endDate.getTime();

    if (endDateTimestamp < dateNow) {
      return false;
    }
  }

  return true;
};
